import { SERVICE_GROUP_ID } from '@/constants';

export const isSubscriptionHodaiPlus = (serviceGroupId: number | null) => {
  return SERVICE_GROUP_ID.hodaiplus == serviceGroupId;
};
